module.exports = __webpack_public_path__ + "media/promotional/bungee-jumping-1de27cf4.jpeg";